<script setup>
import { useRoute } from 'vue-router'
import JournalHistory from '../components/monitoring/JournalHistory.vue'
const route = useRoute()
const actor = typeof route.query.actor === 'string' ? route.query.actor : ''
</script>
<template><JournalHistory journal="audit" :actor="actor" /></template>
